/**
 * Profile tab id for the Connections section. Must match the `id` passed
 * to the Tabs component in `src/pages/main/profile.tsx` for the
 * publishing/connections tab. Centralised here so the Publish dialog's
 * "no connections yet" admin link can jump straight there without
 * duplicating the magic number.
 */
export const CONNECTIONS_TAB_ID = 5;
